const UNEXPECTED_ERROR = `Something went wrong on our end. Please try again, or call us at 1-888-511-6548 if this continues.`;
const EXISTING_ACCOUNT_ERROR = `This email is already linked to another account. Please try a different email address.`;
const FALLACIOUS_EMAIL = `We weren't able to process this email address. Please try a different one, or call us at 1-888-511-6548 for help.`;
const INVALID_ACCOUNT_NUMBER_ERROR = `We couldn't find an account with that number. Please check the number and try again, or use your email address instead.`;
const INVALID_ACCOUNT_ZIP_ERROR = `The account number and zip code don't match our records. Please check both and try again.`;
const EXISTING_VALID_ACCOUNT = `You already have an account with this email. Redirecting you to sign in...`;
const MAIN_TITLE = `Complete your account`;
const ACCOUNT_VERIFICATION_TITLE = `Create your My World Vision account`;
const CONFIRMATION_TITLE = `Your account is ready!`;
const EMAIL_FOUND = `We found your information - just set a password`;

function EXISTING_EMAIL(email) {
  return `You already have an account. Please sign in with ${email}.`;
}

export {
  UNEXPECTED_ERROR,
  EXISTING_ACCOUNT_ERROR,
  FALLACIOUS_EMAIL,
  EXISTING_EMAIL,
  INVALID_ACCOUNT_NUMBER_ERROR,
  INVALID_ACCOUNT_ZIP_ERROR,
  EXISTING_VALID_ACCOUNT,
  MAIN_TITLE,
  ACCOUNT_VERIFICATION_TITLE,
  CONFIRMATION_TITLE,
  EMAIL_FOUND
};
